import * as React from "react";
import { Grid } from "semantic-ui-react";

export interface IApiError {
    id?: number;
    key: string;
    message: string;
}

export interface IAliancaErrors {
    errors: IApiError[];
}

class ExtractErrors {
    public getApiErrors = ({ errors }: IAliancaErrors) => {

        const apiErrors = errors?.filter(x => x.key === "ApiError");

        if (apiErrors.length > 0)
            return (
                <Grid>
                    {apiErrors.map(x =>
                        <Grid.Row textAlign="justified">
                            <Grid.Column>
                                <span role="img" aria-label="x">❌</span>
                                {" "}{x.message}
                            </Grid.Column>
                        </Grid.Row>
                    )}
                </Grid>
            );
    }

    public getErrors = ({ errors }: IAliancaErrors, key: string) => {
        const apiErrors = errors?.filter(error => error.key === key);
        if ((apiErrors?.length || []) > 0) {
            return (
                <Grid>
                    {apiErrors.map(x =>
                        <Grid.Row textAlign="justified">
                            <Grid.Column>
                                <span role="img" aria-label="x">❌</span>
                                {" "}{x.message}
                            </Grid.Column>
                        </Grid.Row>
                    )}
                </Grid>
            );
        }
    }

    public getRawErrors = ({ errors }: IAliancaErrors, key: string) => {
        const apiErrors = errors?.filter(error => error.key === key);
        return apiErrors;
    }

    public getAllErrors = ({ errors }: IAliancaErrors) => {
        if ((errors?.length || []) > 0)
            return (
                <Grid>
                    {errors.map(x =>
                        <Grid.Row textAlign="justified">
                            <Grid.Column>
                                <span role="img" aria-label="x">❌</span>
                                {" "}{x.message}
                            </Grid.Column>
                        </Grid.Row>
                    )}
                </Grid>
            );
    }

    public hasError = ({ errors }: IAliancaErrors, errorKey: string) => {
        const error = errors?.filter(x => x.key === errorKey);

        return error?.length > 0;
    }

    public getMessage = ({ errors }: IAliancaErrors, errorKey: string) => {

        const error = errors?.filter(x => x.key === errorKey);

        if (error?.length > 0)
            return error[0].message;
    }
}

const errors = new ExtractErrors();
export default errors;
